import { NavLink, Link } from "react-router-dom";
import * as userService from "../../utilities/users-service";
import "./NavBar.css";

export default function NavBar({ user, setUser }) {
  function handleLogOut() {
    userService.logOut();
    setUser(null);
  }

  // Convenience helper so we keep className logic in one place
  const linkClass = (isActive, extra = "") =>
    `link ${isActive ? "active-link" : ""} ${extra}`.trim();

  return (
    <nav>
      <NavLink to="/" end className={({ isActive }) => linkClass(isActive)}>
        <h4 className="nav-link">CASES</h4>
      </NavLink>

      <NavLink to="/saber" className={({ isActive }) => linkClass(isActive)}>
        <h4 className="nav-link">S.A.B.E.R.</h4>
      </NavLink>

      {user ? (
        <>
          <NavLink
            to="/instructions"
            className={({ isActive }) => linkClass(isActive)}
          >
            <h4 className="nav-link">ABOUT</h4>
          </NavLink>

          <NavLink to="/user" className={({ isActive }) => linkClass(isActive)}>
            <h4 className="nav-link">MY DATA</h4>
          </NavLink>

          <NavLink
            to="/cases/new"
            className={({ isActive }) =>
              linkClass(isActive, user.admin ? "" : "hidden")
            }
          >
            <h4 className="nav-link">NEW CASE</h4>
          </NavLink>

          <Link className="link logout" to="/" onClick={handleLogOut}>
            <h4 className="nav-link">LOG OUT</h4>
          </Link>
        </>
      ) : (
        <NavLink
          to="/login"
          className={({ isActive }) => linkClass(isActive, "login")}
        >
          <h4 className="nav-link">LOG IN</h4>
        </NavLink>
      )}
    </nav>
  );
}
